import { render } from "./SimulatorView.vue?vue&type=template&id=004c7e42&scoped=true"
import script from "./SimulatorView.vue?vue&type=script&lang=js"
export * from "./SimulatorView.vue?vue&type=script&lang=js"

import "./SimulatorView.vue?vue&type=style&index=0&id=004c7e42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004c7e42"]])

export default __exports__